module.exports = __webpack_public_path__ + "media/images/icon_list/calendar-9c06f3ee3cd45f5f51d7eb1a391808a7.svg";